import { pipe } from 'fp-ts/function';
import { array, number, ord, string } from 'fp-ts';
import { PromotedServiceAssignment, useRepositoryQuery } from '@mews-commander/data-access';

const byOrdering = pipe(
    number.Ord,
    ord.contramap((promotedServiceAssignment: PromotedServiceAssignment) => promotedServiceAssignment.ordering)
);

const byName = pipe(
    string.Ord,
    ord.contramap(
        (promotedServiceAssignment: PromotedServiceAssignment) => promotedServiceAssignment.promotedServiceName
    )
);

const bySpaceCategory = pipe(
    string.Ord,
    ord.contramap(
        (promotedServiceAssignment: PromotedServiceAssignment) => promotedServiceAssignment.promotedResourceCategoryName
    )
);

export const usePromotedServices = (serviceId: string) =>
    useRepositoryQuery(
        'promotedServiceAssignments',
        'getAll',
        {
            serviceId,
        },
        {
            select: ({ promotedServiceAssignments }) =>
                pipe(promotedServiceAssignments, array.sortBy([byOrdering, byName, bySpaceCategory])),
        }
    );
